import { http } from "../http";

const signup = (data: any) => {
  return http.post("/users/signup", data);
};

const signin = (data: any) => {
  return http.post("/users/clinician-signin", data);
};

const forgotPassword = (data: any) => {
  const formData = { ...data, type: "EMAIL" };
  return http.post("/users/otp", formData);
};

const resetPassword = (data: any) => {
  return http.post("/users/reset-password", data);
};

const submitClinicianApplication = (data: any) => {
  return http.post("/clinician-application", data);
};

const getClinicianOnboarding = (token: string) => {
  return http.get(`/users/clinician-onboarding/${encodeURIComponent(token)}`);
};

const patchClinicianOnboarding = (token: string, data: any) => {
  return http.patch(
    `/users/clinician-onboarding/${encodeURIComponent(token)}`,
    data
  );
};

const setClinicianOnboardingPassword = (token: string, password: string) => {
  return http.post(
    `/users/clinician-onboarding/${encodeURIComponent(token)}/set-password`,
    { password }
  );
};

export {
  signin,
  signup,
  forgotPassword,
  resetPassword,
  submitClinicianApplication,
  getClinicianOnboarding,
  patchClinicianOnboarding,
  setClinicianOnboardingPassword,
};
